<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Metode Pembayaran
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">
                <h3 class="mb5">Pilih Metode Pembayaran</h3>
                <p class="mt0 mb5">Berikut pilihan metode pembayaran yang telah kami sediakan. Monggo dipilih huehehe</p>
                <p class="mt0 mb10 info p5 biru">Pembayaran di dukung oleh <br>My Wifi dan Beatcom RTRW ya :)</p>
            </div>
            <div class="body">
                <div class="box" v-show="false">
                        <p class="red">
                            Maaf. Setelah uji coba perilisan kemarin ternyata masih banyak bug yang harus di benahi.
                            Jadi kami akan memperbaiki kembali ya gan. Terima kasih dan harap maklum :)
                        </p>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">QRIS</span>
                        <small class="biru text-right">Ada Biaya Operasional</small>
                    </div>
                    <div class="bayar-item last " v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.qris()">
                        <img src="@/assets/qris.png" />
                        <span>QRIS (QR berstandar resmi Indonesia)</span>
                    </div>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Outlet</span>
                        <small class="biru text-right">Biaya Admin Flat Alfamart dan Alfamidi  Rp. 6.000 dan Indomaret Rp. 8000,, Minimal Pembayaran Rp. 10.000</small>
                    </div>
                    <div class="bayar-item " @click="met.indomaret()" v-bind:class="{'comingsoon' : get.data.viaIndomaret === 'tidak'}"> <!--   -->
                        <img src="@/assets/indomaret.png" />
                        <div>
                            <span style="display:block">Indomaret</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                    <div class="bayar-item" @click="met.alfamart()" v-bind:class="{'comingsoon' : get.data.viaAlfamart === 'tidak'}"> <!--   -->
                        <img src="@/assets/alfamart.png" />
                        <div>
                            <span style="display:block">Alfamart</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                    <div class="bayar-item last" @click="met.alfamidi()" v-bind:class="{'comingsoon' : get.data.viaAlfamidi === 'tidak'}">
                        <img src="@/assets/alfamidi.png" />
                        <div>
                            <span style="display:block">Alfamidi</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Virtual Account</span>
                        <small class="biru text-right">Biaya Admin Flat Rp. 6.000</small>
                    </div>
                    <div class="bayar-item" @click="met.mandiri()" v-bind:class="{'comingsoon' : get.data.viaMandiri === 'tidak'}">
                        <img src="@/assets/mandiri.png" />
                        <span>Mandiri Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.bri()" v-bind:class="{'comingsoon' : get.data.viaBRI === 'tidak'}"> <!--   -->
                        <img src="@/assets/bri.png" />
                        <span>BRI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.bni()" v-bind:class="{'comingsoon' : get.data.viaBNI === 'tidak'}">
                        <img src="@/assets/bni.png" />
                        <span>BNI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" v-bind:class="{'comingsoon' : get.data.viaPermata === 'tidak'}" @click="met.permata()">
                        <img src="@/assets/permata.png" />
                        <span>PERMATA Virtual Akun</span>
                    </div>
                    <div class="bayar-item comingsoon" @click="met.segera()">
                        <img src="@/assets/bca.png" />
                        <span>BCA Virtual Akun</span>
                    </div>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Dompet Digital</span>
                        <small class="biru text-right">Biaya Admin 3% dari Total Tagihan</small>
                    </div>
                    <div class="bayar-item comingsoon" v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.segera()"> 
                        <img src="@/assets/link.png" />
                        <span>Link Aja</span>
                    </div>
                    <div class="bayar-item comingsoon" v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.segera()"> <!-- link  ovo  @click="met.segera()" -->
                        <img src="@/assets/ovo.png" />
                        <span>Ovo</span>
                    </div>
                    <div class="bayar-item comingsoon" @click="met.segera()"> <!-- v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.dana()" -->
                        <img src="@/assets/dana.png" />
                        <span>Dana</span>
                    </div>
                </div>
            </div>
            <div class="footer">
                <p class="text-center">Pembayaran diatas akan memproses tagihan anda secara otomatis.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/MyGlobal'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                allDone: false,
                custom: null,

                viaQris: null,
                viaPermata: null,
                viaMandiri: null,
                viaBRI: null,
                viaBNI: null,
                viaAlfamart: null,
                viaAlfamidi: null,
                viaIndomaret: null
            })    
        }

        const met = {
            segera() {
                myGlobal.android("toast", "Segera ya bun :)");
            },
            alfamidi() {
                if (get.data.viaAlfamidi == 'tidak') {
                    this.segera();
                    return;
                }

                if (get.data.custom === 'custom') {
                    router.push({ 
                        name: 'detail',
                        params: {
                            jenis: 'tripay-retail',
                            via: 'ALFAMIDI'
                        }
                    });
                }
            },
            indomaret() {
                if (get.data.viaIndomaret == 'tidak') {
                    this.segera();
                    return;
                }

                if (get.data.custom === 'custom') {
                    router.push({ 
                        name: 'detail',
                        params: {
                            jenis: 'tripay-retail',
                            via: 'INDOMARET'
                        }
                    });
                }
            },
            alfamart() {
                if (get.data.viaAlfamart == 'tidak') {
                    this.segera();
                    return;
                }

                if (get.data.custom === 'custom') {
                    router.push({ 
                        name: 'detail',
                        params: {
                            jenis: 'retail',
                            via: 'ALFAMART'
                        }
                    });
                }
            },
            permata() {
                if (get.data.viaPermata == 'tidak') {
                    this.segera();
                    return;
                }
                
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'va',
                        via: 'PERMATA'
                    }
                });
            },
            bni() {
                if (get.data.viaBNI == 'tidak') {
                    this.segera();
                    return;
                }
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'va',
                        via: 'BNI'
                    }
                });
            },
            bri() {
                if (get.data.viaBRI == 'tidak') {
                    this.segera();
                    return;
                }

                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'va',
                        via: 'BRI'
                    }
                });
            },
            mandiri() {
                if (get.data.viaMandiri == 'tidak') {
                    this.segera();
                    return;
                }
                
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'va',
                        via: 'MANDIRI'
                    }
                });
            },
            ovo() {
                if (get.data.viaQris == 'tidak') {
                    this.segera();
                    return;
                }
                
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'ewallet',
                        via: 'ovo'
                    }
                });
            },
            dana() {
                if (get.data.viaQris == 'tidak') {
                    this.segera();
                    return;
                }
                
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'ewallet',
                        via: 'dana'
                    }
                });
            },
            link() {
                if (get.data.viaQris == 'tidak') {
                    this.segera();
                    return;
                }

                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'ewallet',
                        via: 'linkaja'
                    }
                });
            },
            qris() {
                if (get.data.viaQris == 'tidak') {
                    this.segera();
                    return;
                }

                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: 'qris',
                        via: 'qris'
                    }
                });
            },
            
            back() {
                window.history.back();
            }
        }
        
        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            myGlobal,
            store,
            met,
            get,
            redirectx
        }

    },
    mounted () {
        //window.Token = this.token.get;

        console.log("fakkis");
        
        this.redirectx.checkApp();

        this.get.data.this = this;        
        
        //myGlobal.android("setTitle", "Pilih Metode");

        if (sessionStorage.getItem("data_profil") != null) {
            var d = JSON.parse(sessionStorage.getItem("data_profil"));
            
            this.get.data.custom = d.atipe;

            var payment = d.payment;
            for (let i = 0; i < payment.length; i++) {
  
                if (payment[i].kode == 'qris') {
                    this.get.data.viaQris = payment[i].status;

                } else if(payment[i].kode == 'PERMATA') {
                    this.get.data.viaPermata = payment[i].status;

                } else if(payment[i].kode == 'MANDIRI') {
                    this.get.data.viaMandiri = payment[i].status;

                } else if(payment[i].kode == 'BRI') {
                    this.get.data.viaBRI = payment[i].status;

                } else if(payment[i].kode == 'BNI') {
                    this.get.data.viaBNI = payment[i].status;

                } else if(payment[i].kode == 'ALFAMART') {
                    this.get.data.viaAlfamart = payment[i].status;

                } else if(payment[i].kode == 'ALFAMIDI') {
                    this.get.data.viaAlfamidi = payment[i].status;

                } else if(payment[i].kode == 'INDOMARET') {
                    this.get.data.viaIndomaret = payment[i].status;

                }
            }

            //console.log(this.get.data.viaQris);
            
        }
        

        
        //this.store.dispatch('setToken', {'token': "blablabla"});

        
        
        //this.get.tagihan();

        // AMBIL TAGIHAN
        
        
        /*
        if (appmyrtrw) {
            appmyrtrw.setTitle("Pilih Metode");
            
            this.token.get(appmyrtrw.getToken()); 
            this.$store.commit('setToken', appmyrtrw.getToken());
        }
        */

        /*
        try {
        // eslint-disable-next-line no-undef
        } catch (error) {
            console.log("oops tidak boleh bambang");
            this.redirectx.now();
        } 
        */
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Pembayaran/main.vue